export default __webpack_public_path__ + "static/media/fevr-ecosystem.8f1fdab3.png";